// extracted by mini-css-extract-plugin
module.exports = {"tools":"SummaryBoard_tools__18hv4","switchGroup":"SummaryBoard_switchGroup__3tzj3"};